(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    document.querySelectorAll('main slider-component').forEach(root => {
      if (root.dataset.ozAutoplay) return;
      const track = root.querySelector('[id^="Slider-"]');
      if (!track || !track.classList.contains('slider')) return;
      root.dataset.ozAutoplay = 'true';
      const section = root.closest('.shopify-section');
      const heading = section?.querySelector('h2')?.textContent.trim() || 'carousel';
      const controls = document.createElement('div');
      controls.className = 'visually-hidden';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary';
      button.setAttribute('aria-controls', track.id);
      controls.append(button);
      root.after(controls);
      let paused = reducedMotion.matches;
      let touchedUntil = 0;
      const update = () => {
        controls.hidden = track.scrollWidth <= track.clientWidth + 4;
        button.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
        button.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} ${heading} slideshow`);
        button.setAttribute('aria-pressed', String(paused));
      };
      button.addEventListener('click', () => { paused = !paused; update(); });
      root.addEventListener('pointerdown', () => { touchedUntil = Date.now() + 8000; });
      root.addEventListener('touchstart', () => { touchedUntil = Date.now() + 8000; }, { passive: true });
      const onMotion = () => { paused = reducedMotion.matches; update(); };
      reducedMotion.addEventListener('change', onMotion);
      const observer = new ResizeObserver(update);
      observer.observe(track);
      update();
      const timer = setInterval(() => {
        if (!root.isConnected) {
          clearInterval(timer); observer.disconnect();
          reducedMotion.removeEventListener('change', onMotion); controls.remove(); return;
        }
        if (paused || document.hidden || Date.now() < touchedUntil || root.matches(':hover') || root.contains(document.activeElement)) return;
        const rect = track.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight || !track.clientWidth) return;
        const end = track.scrollWidth - track.clientWidth;
        if (end <= 4) return;
        const slides = Array.from(track.children).filter(el => el.getBoundingClientRect().width > 0);
        const step = slides.length > 1 ? Math.abs(slides[1].offsetLeft - slides[0].offsetLeft) : track.clientWidth;
        const rtl = getComputedStyle(track).direction === 'rtl';
        const current = Math.abs(track.scrollLeft);
        const next = current >= end - 16 ? 0 : Math.min(end, current + step);
        track.scrollTo({ left: rtl ? -next : next, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }, 6000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
